import { DatePipe, formatDate } from '@angular/common';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { PayoutCreation, PayoutStatus } from '../_enums/payout';
import { AuthService, BackFilterService, CustomerService, PayoutService, UserService } from '../_services';
import { AppConfig, ExcelService, PreviousRouteService } from '../_helpers/index';
import { PayoutList, PayoutAdd } from '../_models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'payoutprocesslist',
  templateUrl: './payoutprocesslist.component.html',
  styleUrls: ['../../assets/css/customer-list-table.css']
})

export class PayoutProcessListComponent implements OnInit {
  ddlPayoutStatus: any[];
  ddlPayoutCreation: any[];
  searchFilterForm: FormGroup;
  searchRangoFilterForm: FormGroup;
  isRangoVisiable = false;
  filterValue;
  displayedColumns: string[] = ['created', 'reference', 'name', 'gross_amount.value', 'net_amount.value', 'status', 'actions'];
  dataSourcePayoutList = new MatTableDataSource();
  public user_public_id: string;
  customer_public_id: string;
  offsetTimeZone: any;
  offsetMinutes: any;
  offsetTimeVal: any;
  accountId: any;
  isCreateAvailable = false;
  isReadAvailable = true;
  isCancelAvailable = true;
  isApproveAvailable = true;
  isAccountReadAvailable = true;
  isImportAvailable: boolean = false;
  pageSize: number;
  PageSizeOptions: number[];
  userDetails: any;
  userRole: any;
  userRoleStatus: any;
  payoutAddForm: FormGroup;
  accountList: any;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("payoutLowBalanceModel") modalContent;
  cancelPayoutId: any;
  startDate: any;
  endDate: any;
  payoutList = [];
  status: any;
  TotalResultSize: any;
  pageIndex: number = 0;
  pageStart: number = 0;
  searchValue = '';
  statusDropdownValue = 0;
  creationDropdownValue = 0;
  statusFormControl = new FormControl(0);
  creationFormControl = new FormControl(0);
  tempSearch: any;
  backToSearchSharedData: any;
  previousUrl: any;
  isBrowserBackButtonPressed: boolean = false;
  isCancelPreApprovedAvailable: boolean = false;

  messageTitle: string;
  messageBody: string;


  constructor(private _fb: FormBuilder,
    private payoutCreation: PayoutCreation,
    private payoutStatus: PayoutStatus,
    private datePipe: DatePipe,
    private payoutService: PayoutService,
    private spinnerService: Ng4LoadingSpinnerService,
    private router: Router,
    private auth: AuthService,
    private userService: UserService,
    private customerService: CustomerService,
    private modalService: NgbModal,
    private backFilterService: BackFilterService,
    private previousRouteService: PreviousRouteService) {
    this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
    this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;
    this.InitialSetup();
    this.backFilterService.getPayoutSearchSharedData().subscribe(data => this.backToSearchSharedData = data);
    this.backFilterService.getIsBrowserBackButtonPressedSharedData().subscribe(data => this.isBrowserBackButtonPressed = data);
    
    const navigation = this.router.getCurrentNavigation();
    if (navigation.extras.state) {
      this.messageTitle = navigation.extras.state.title;
      this.messageBody = navigation.extras.state.body;
    }
  }

  InitialSetup() {
    this.payoutAddForm = this._fb.group({
      name: new FormControl('', [Validators.required, Validators.maxLength(50), Validators.pattern("[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+")]),
    })

  }

  ngOnInit() {
    this.spinnerService.show();
    this.checkThisPageGrants();
    var browserStorage;
    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      }
      else {
        this.customer_public_id = localStorage.getItem('companyId');
        this.user_public_id = localStorage.getItem('userId');
      }
    }
    else {
      this.customer_public_id = localStorage.getItem('subcompanyId');
      this.user_public_id = localStorage.getItem('userId');
    }

    browserStorage = (typeof localStorage === 'undefined') ? null : localStorage;
    this.offsetTimeZone = (typeof browserStorage.getItem('timezone') === 'undefined') ? null : browserStorage.getItem('timezone');

    if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {
      this.offsetTimeZone = -5.00;
      this.offsetMinutes = 0;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }
    else {
      this.offsetTimeZone = browserStorage.getItem('timezone');
      this.offsetMinutes = 30;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }
    this.ddlPayoutCreation = this.payoutCreation._creation;
    this.ddlPayoutStatus = this.payoutStatus._status;

    if (this.payoutCreation._creation.length > 8) {
      this.payoutCreation._creation.shift();
    }

    this.searchRangoFilterForm = this._fb.group({
      searchFromDate: [''],
      searchToDate: ['']
    });

    this.paginator._intl.itemsPerPageLabel = "Registros por página";
    this.paginator._intl.nextPageLabel = "siguiente página";
    this.paginator._intl.lastPageLabel = "última página";
    this.paginator._intl.previousPageLabel = "anterior página";
    this.paginator._intl.firstPageLabel = "primera página";
    this.startDate = "";
    this.endDate = "";
    this.status = "";

    //back to search start
    this.previousUrl = this.previousRouteService.getPreviousUrl();
    if ((this.isBrowserBackButtonPressed == true) &&
      (this.previousUrl.includes("/payout_process/")) &&
      (this.previousUrl.includes("/view"))
    ) {
      this.backFilterService.setIsBrowserBackButtonPressedSharedData(false);
      this.setBackToSearchData();
    }else{
      this.backFilterService.setIsBrowserBackButtonPressedSharedData(false);
      this.backFilterService.setPayoutSharedData(null);
    }
    //back to search end

    this.searchFilterForm = this._fb.group({
      searchText: [this.searchValue, Validators.required]
    });

    this.getPayoutProcessList();
    this.getCustomerAccountList();
  }

  setBackToSearchData(){
    if (this.backToSearchSharedData != null) {
      this.searchValue = this.backToSearchSharedData.search;
      this.status = this.backToSearchSharedData.status;
      this.statusFormControl.setValue(this.backToSearchSharedData.statusDropdownValue);
      this.creationFormControl.setValue(this.backToSearchSharedData.creationDropdownValue);
      this.statusDropdownValue = this.backToSearchSharedData.statusDropdownValue;
      this.creationDropdownValue = this.backToSearchSharedData.creationDropdownValue;
      this.pageSize = this.backToSearchSharedData.pageSize;
      this.pageIndex = this.backToSearchSharedData.pageIndex;
      this.pageStart = this.backToSearchSharedData.pageStart;
      this.paginator.pageIndex = this.pageIndex;
      if (this.backToSearchSharedData.creationDropdownValue == 8) {
        this.searchRangoFilterForm = this._fb.group({
          searchFromDate: [this.backToSearchSharedData.searchFromDate],
          searchToDate: [this.backToSearchSharedData.searchToDate]
        });
        this.filterValue = this.datePipe.transform(this.searchRangoFilterForm.controls.searchFromDate.value, "dd/MM/yyyy") + '-' + this.datePipe.transform(this.searchRangoFilterForm.controls.searchToDate.value, "dd/MM/yyyy");
        this.ddlPayoutCreation.unshift({ value: 8, name: this.filterValue });
        this.isRangoVisiable = false;
        this.startDate = this.convertGMTTime(new Date(formatDate(this.searchRangoFilterForm.controls.searchFromDate.value, 'yyyy-MM-dd 00:00:00', 'en-US')));
        this.endDate = this.convertGMTTime(new Date(formatDate(this.searchRangoFilterForm.controls.searchToDate.value, 'yyyy-MM-dd 23:59:00', 'en-US')));
        this.creationFormControl.setValue(8);
        this.creationDropdownValue = 8;
      }else {
        this.startDate = this.backToSearchSharedData.creationStartDate;
        this.endDate = this.backToSearchSharedData.creationEndDate;
      }
      this.setBackToSearchFilter();
    }
  }

  getPayoutProcessList() {
    this.payoutService.getPayoutProcessList(this.customer_public_id, this.status, this.startDate, this.endDate, this.pageSize, this.pageStart, this.searchValue).subscribe(data => {
      let resources = data["data"];
      this.dataSourcePayoutList.data = resources;
      this.TotalResultSize = data.records;
      this.paginator.pageIndex = this.pageIndex;
      this.spinnerService.hide();
    }, error => {
      console.log('Failed! while trying to get the Operation Payout List. ' + error.error)
    })
  }

  getPayoutProcessListForFilter() {
    this.spinnerService.show();
    this.pageStart = 0;
    this.pageIndex = 0;
    this.setBackToSearchFilter();
    this.getPayoutProcessList();
    this.paginator.pageIndex = 0;
  }

  gridPageChange(event) {
    this.spinnerService.show();
    this.pageSize = event.pageSize;
    this.pageStart = event.pageIndex * event.pageSize;
    this.pageIndex = event.pageIndex;
    this.payoutService.getPayoutProcessList(this.customer_public_id, this.status, this.startDate, this.endDate, this.pageSize, this.pageStart, this.searchValue).subscribe(data => {
      let resources = data["data"];
      this.dataSourcePayoutList.data = resources;
      this.spinnerService.hide();
    },
      error => {
        console.log('Failed! while trying to get the Operation Payout List. ' + error.error)
      })
    this.setBackToSearchFilter();
  }

  getProperty = (obj, path) => (
    path.split('.').reduce((o, p) => o && o[p], obj)
  )

  ngAfterViewInit() {
    this.dataSourcePayoutList.sortingDataAccessor = (obj, property) => this.getProperty(obj, property);
    this.dataSourcePayoutList.sort = this.sort;
  }

  applyFilter() {
    this.searchValue = this.searchFilterForm.controls.searchText.value;
    this.searchValue = this.searchValue.trim().toLowerCase();
    this.getPayoutProcessListForFilter();
  }

  filterCreationDetails(creation) {
    this.creationDropdownValue = creation;
    var currentDate = new Date();

    var currentweekFirstDate = new Date();
    var currentweekLastDate = new Date();

    var lastweekFirstDate = new Date();
    var lastweekLastDate = new Date();

    currentweekFirstDate.setDate(currentweekFirstDate.getDate() - currentweekFirstDate.getDay());
    currentweekLastDate.setDate(currentweekFirstDate.getDate() + 7);

    var currentmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    var currentmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    var lastmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
    var lastmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);

    lastweekFirstDate.setDate(lastweekFirstDate.getDate() - 7);
    lastweekLastDate.setDate(lastweekFirstDate.getDate() + 6);




    // All Datas Condition
    if (creation == 0) {
      this.startDate = "";
      this.endDate = "";
      this.getPayoutProcessListForFilter();
    }

    // Current Month Filter Condition
    if (creation == 1) {
      this.startDate = this.convertGMTTime(new Date(formatDate(currentmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
      this.endDate = this.convertGMTTime(new Date(formatDate(currentmonthLastDate, 'yyyy-MM-dd 23:59:00', 'en-US')));
      this.getPayoutProcessListForFilter();
    }

    // Current Week Filter Condition
    if (creation == 2) {
      this.startDate = this.convertGMTTime(new Date(formatDate(currentweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
      this.endDate = this.convertGMTTime(new Date(formatDate(currentweekLastDate, 'yyyy-MM-dd 23:59:00', 'en-US')));
      this.getPayoutProcessListForFilter();
    }

    // Today Filter Condition
    if (creation == 3) {
      currentDate.setDate(currentDate.getDate());
      this.startDate = this.convertGMTTime(new Date(formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
      this.endDate = this.convertGMTTime(new Date(formatDate(currentDate, 'yyyy-MM-dd 23:59:00', 'en-US')));
      this.getPayoutProcessListForFilter();
    }

    // Yesterday Filter Condition
    if (creation == 4) {
      currentDate.setDate(currentDate.getDate() - 1);
      this.startDate = this.convertGMTTime(new Date(formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
      this.endDate = this.convertGMTTime(new Date(formatDate(currentDate, 'yyyy-MM-dd 23:59:00', 'en-US')));
      this.getPayoutProcessListForFilter();
    }


    // Last Week Filter Condition
    if (creation == 5) {
      this.startDate = this.convertGMTTime(new Date(formatDate(lastweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
      this.endDate = this.convertGMTTime(new Date(formatDate(lastweekLastDate, 'yyyy-MM-dd 23:59:00', 'en-US')));
      this.getPayoutProcessListForFilter();
    }

    // Last Month Filter Condition
    if (creation == 6) {
      this.startDate = this.convertGMTTime(new Date(formatDate(lastmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
      this.endDate = this.convertGMTTime(new Date(formatDate(lastmonthLastDate, 'yyyy-MM-dd 23:59:00', 'en-US')));
      this.getPayoutProcessListForFilter();
    }
    // Range Filter Condition
    if (creation == 7) {
      this.startDate = "";
      this.endDate = ""
      this.isRangoVisiable = true;
    }
    else {
      this.isRangoVisiable = false;
    }

    if (creation == 8) {
      this.startDate = this.convertGMTTime(new Date(formatDate(this.searchRangoFilterForm.controls.searchFromDate.value, 'yyyy-MM-dd 00:00:00', 'en-US')));
      this.endDate = this.convertGMTTime(new Date(formatDate(this.searchRangoFilterForm.controls.searchToDate.value, 'yyyy-MM-dd 23:59:00', 'en-US')));
      this.getPayoutProcessListForFilter();
    }
  }

  filterStatusDetails(status) {
    this.statusDropdownValue = status;
    if (status == this.ddlPayoutStatus[0].value) {
      this.status = "all"
    }
    else if (status == this.ddlPayoutStatus[1].value) {
      this.status = '(1)';
    }
    else if (status == this.ddlPayoutStatus[2].value) {
      this.status = '(2)';
    }
    else if (status == this.ddlPayoutStatus[3].value) {
      this.status = '(3)';
    }
    else if (status == this.ddlPayoutStatus[4].value) {
      this.status = '(4)';
    }
    else if (status == this.ddlPayoutStatus[5].value) {
      this.status = '(0)';
    }
    else if (status == this.ddlPayoutStatus[6].value) {
      this.status = '(5)';
    }
    else if (status == this.ddlPayoutStatus[7].value) {
      this.status = '(6)';
    }
    else {
      this.status = "all"
    }

    this.getPayoutProcessListForFilter();
  }

  filterAllDetails() {
    if (this.searchRangoFilterForm.controls.searchFromDate.value !== null && this.searchRangoFilterForm.controls.searchToDate.value !== null
      && this.searchRangoFilterForm.controls.searchFromDate.value !== '' && this.searchRangoFilterForm.controls.searchToDate.value !== ''
    ) {
      this.filterRangoDetails();
    }
    else {
      this.isRangoVisiable = false;
      this.creationFormControl.setValue(0);
      this.creationDropdownValue = 0;
      this.startDate = '';
      this.endDate = '';
      this.getPayoutProcessListForFilter();
    }
  }

  filterRangoDetails() {
    if (this.payoutCreation._creation.length > 8) {
      this.payoutCreation._creation.shift();
    }
    this.filterValue = this.datePipe.transform(this.searchRangoFilterForm.controls.searchFromDate.value, "dd/MM/yyyy") + '-' + this.datePipe.transform(this.searchRangoFilterForm.controls.searchToDate.value, "dd/MM/yyyy");
    this.ddlPayoutCreation.unshift({ value: 8, name: this.filterValue });
    this.isRangoVisiable = false;
    this.startDate = this.convertGMTTime(new Date(formatDate(this.searchRangoFilterForm.controls.searchFromDate.value, 'yyyy-MM-dd 00:00:00', 'en-US')));
    this.endDate = this.convertGMTTime(new Date(formatDate(this.searchRangoFilterForm.controls.searchToDate.value, 'yyyy-MM-dd 23:59:00', 'en-US')));
    this.creationFormControl.setValue(8);
    this.creationDropdownValue = 8;
    this.getPayoutProcessListForFilter();
  }

  convertGMTTime(startDate1) {
    if (this.offsetTimeZone > 0) {
      let date: any = new Date(startDate1);
      var dateTimeZoneDiff = new Date(date);
      dateTimeZoneDiff.setMilliseconds(Number(this.offsetTimeVal));
      let startDate = formatDate(dateTimeZoneDiff, 'yyyy-MM-dd HH:mm:ss', 'en-US');
      return startDate;
    }
    else {
      var startDate2 = new Date(startDate1.setHours(startDate1.getHours() - this.offsetTimeZone));
      var startDate3 = new Date(startDate2.setMinutes(startDate2.getMinutes() - this.offsetMinutes));
      let startDate = formatDate(startDate3, 'yyyy-MM-dd HH:mm:ss', 'en-US');
      return startDate;
    }
  }

  save({ value }: { value: PayoutAdd }) {
    this.spinnerService.show();
    let payoutAccountList = this.accountList.filter(t => t.type == 'PAYOUT');
    let payableAccountList = this.accountList.filter(t => t.type == 'PAYABLE');
    if (payoutAccountList.length > 0) {
      let createPayoutProcess = {
        "company_account": { "public_id": payoutAccountList[0].public_id },
        "name": value.name
      }
      this.payoutService.createPayoutProcess(createPayoutProcess).subscribe(result => {
        if (result.status == '201') {
          this.getPayoutProcessList();
        } else {
          this.spinnerService.hide();
          console.log('API Response:' + JSON.stringify(result));
        }
      },
        error => {
          this.spinnerService.hide();
          console.log('Failed while trying to create the createPayoutProcess.' + error)
        })
    } else {
      this.spinnerService.hide();
      console.log('PAYOUT type account is not available for this user.')
    }
    //
  }

  getCustomerAccountList() {
    this.customerService.getCustomerAccountList(this.customer_public_id, '').subscribe(data => {
      this.accountList = data;
    },
      error => {
        console.log('Failed! while trying to get the accounts list. ' + error);
      });
  }

  async getUserRoleStatus() {
    try {
      const data = await this.userService.getUserDetails(localStorage.getItem('userId'));
      this.userDetails = data;
      this.userRole = this.userDetails.role;
      this.userRoleStatus = this.userDetails.status;
    }
    catch (error) {
      console.log('Failed while trying to getUserRoleStatus.' + error)
    }

  }

  payoutProcessGridActionClick(type, publicid, companyAccountPublicId = "") {
    switch (type) {
      case 'READ':
        this.router.navigate([`/payout_process/${publicid}/view`]);
        break;
      case 'CANCEL':
        this.cancelPayoutId = publicid;
        break;
      case 'APPROVE':
        this.approve(publicid, companyAccountPublicId)
        break;
    }
  }

  approve(publicid, companyAccountPublicId) {
    this.spinnerService.show();
    let payableAccountList = this.getPayableAccountList(companyAccountPublicId, this.accountList);
    let executePayoutProcess = {
      "confirm_payout": { "to_account": { "public_id": payableAccountList } }
    }
    this.payoutService.executePayoutProcess(publicid, executePayoutProcess).subscribe(result => {
      this.getPayoutProcessList();
    },
      err => {
        if (err.status == 400 && err.error == "No balance in Payout Account") {
          this.openLowBalanceModel();
        }
        this.spinnerService.hide();
        if (err.status != 400) {
          console.log('Failed while trying to approve the payout.' + err.error);
        }
      })
  }

  getPayableAccountList(publicId: string, accountList) {
    const accountSelected = accountList.find(t => t.public_id === publicId).balance.currency;
    return accountList.find(t => t.type === 'PAYABLE' && t.balance.currency === accountSelected).public_id;
  }

  cancelPayoutProcess() {
    this.spinnerService.show();
    this.payoutService.cancelPayoutProcess(this.cancelPayoutId).subscribe(result => {
      this.getPayoutProcessList();
    },
      error => {
        this.spinnerService.hide();
        console.error('Failed while trying to cancel the PayoutProcess.' + error);
      })
  }

  openLowBalanceModel() {
    this.modalService.open(this.modalContent, { ariaLabelledBy: 'payoutLowBalanceModelTitle' })
  }

  goToAccount() {
    let payoutAccountList = this.accountList.filter(t => t.type == 'PAYOUT');
    if (payoutAccountList.length > 0) {
      this.router.navigate([`/accounts/payout/${payoutAccountList[0].public_id}/operations`]);
    }
  }

  async checkThisPageGrants() {
    await this.auth.isKashioGrantsAvailable();
    await this.getUserRoleStatus();
    this.isImportAvailable = this.auth.checkGrants('PAYOUTS', 'IMPORT');
    this.isReadAvailable = this.auth.checkGrants('PAYOUTS', 'READ');
    this.isApproveAvailable = this.auth.checkGrants('PAYOUTS', 'APPROVE');
    this.isCancelAvailable = this.auth.checkGrants('PAYOUTS', 'CANCEL');
    this.isAccountReadAvailable = this.auth.checkGrants('ACCOUNTS', 'READ');
    //if(this.userRole == 'KashIO-OPS' && this.userRoleStatus == 'ACTIVE'){
    this.isCreateAvailable = this.auth.checkGrants('PAYOUTS', 'CREATE');
    this.isCancelPreApprovedAvailable = this.auth.checkGrants('PAYOUTS', 'CANCEL-PREAPPROVED');
    //}
  }

  setBackToSearchFilter() {
    this.tempSearch = {
      search: this.searchValue,
      creationStartDate: this.startDate,
      creationEndDate: this.endDate,
      status: this.status,
      statusDropdownValue: this.statusDropdownValue,
      creationDropdownValue: this.creationDropdownValue,
      searchFromDate: this.searchRangoFilterForm.controls.searchFromDate.value,
      searchToDate: this.searchRangoFilterForm.controls.searchToDate.value,
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      pageStart: this.pageStart
    }
    this.backFilterService.setPayoutSharedData(this.tempSearch);
  }
}